import * as React from 'react';
import { FeatureFlags } from '@authe/fe-commons/flags';
import { jsx } from 'react/jsx-runtime';

// src/flags/FlagsProvider.tsx
var FlagsContext = React.createContext(null);
function FlagsProvider({ flags, children }) {
  return /* @__PURE__ */ jsx(FlagsContext.Provider, { value: flags, children });
}
function useFeatureFlags() {
  const flags = React.useContext(FlagsContext) ?? EMPTY_FLAGS;
  React.useSyncExternalStore(flags.subscribe, flags.getRevision, flags.getRevision);
  return flags;
}
function useFeatureFlag(name) {
  return useFeatureFlags().isEnabled(name);
}
var EMPTY_FLAGS = new FeatureFlags();

export { FlagsProvider, useFeatureFlag, useFeatureFlags };
//# sourceMappingURL=chunk-ATO7ZCLZ.js.map
//# sourceMappingURL=chunk-ATO7ZCLZ.js.map